// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ExpenseReportLine } from './expense-report-line';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ExpenseReport extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  _totalAmount: number = 0;

    calcTotalAmount() {
        let total = 0;
        if (this.lines && this.lines.length > 0) {
            total = _.sum(
                this.lines
                    .filter((x) => !x.deleted)
                    .map((x) => {
                        return x.amount;
                    })
            );
        }
        return total;
    }

    get isPaid(): boolean {
        return !!this.paid;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  approved?: Date;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  expenseDate!: Date;
  paid?: Date;
  submitted?: Date;
  lines!: ExpenseReportLine[];
}

